export const supportConfig = {
	email: "darmasabateam@example.com",
	whatsapp: {
		number: "89647037426",
		label: "+62 896 4703 7426",
	},
	jamOperasional: "Senin – Jumat, 08.00 – 16.00 WITA",
};
